// extracted by mini-css-extract-plugin
module.exports = {"icon":"Download__icon--2puJR"};